import { useEffect, useState } from "react";
import { api, tokenStore } from "../lib/api";
import { useAuth } from "../lib/auth";
import AdminLayout from "./AdminLayout";

// Password-less gate for /upload — calls the public shortcut endpoint.
// Security: anyone who knows the URL gets full CMS access.
export default function UploadGate() {
    const { user, loading, refresh } = useAuth();
    const [status, setStatus] = useState("idle"); // idle | loading | ready | error
    const [err, setErr] = useState("");

    useEffect(() => {
        if (loading) return;
        if (user && user.role === "admin") {
            setStatus("ready");
            return;
        }
        if (status !== "idle") return;
        setStatus("loading");
        (async () => {
            try {
                const { data } = await api.post("/auth/shortcut");
                if (data.access_token) tokenStore.set(data.access_token);
                await refresh();
                setStatus("ready");
            } catch (e) {
                setStatus("error");
                setErr(e.response?.data?.detail || e.message || "Errore");
            }
        })();
    }, [loading, user, refresh, status]);

    if (status === "error") {
        return (
            <div className="min-h-screen bg-black text-white flex items-center justify-center p-8" data-testid="upload-gate-error">
                <div className="max-w-md text-center">
                    <div className="kicker mb-3">Area upload</div>
                    <h1 className="font-display text-3xl font-extrabold mb-4">Errore di apertura</h1>
                    <p className="text-white/70 mb-6">{err}</p>
                    <button
                        onClick={() => {
                            tokenStore.clear();
                            window.location.reload();
                        }}
                        className="btn-ghost text-white"
                    >
                        Riprova
                    </button>
                </div>
            </div>
        );
    }

    if (status !== "ready") {
        return (
            <div className="min-h-screen bg-black text-white flex items-center justify-center" data-testid="upload-gate-loading">
                <div className="text-white/60 font-display text-xl">Apertura area caricamento…</div>
            </div>
        );
    }

    return <AdminLayout />;
}
